import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getDamzModule } from './module';
import useNCI18next from '../hooks/useI18next';
const ModuleLoader = ()=>{
    useNCI18next();
    return /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getDamzModule()
        ]
    });
};
ModuleLoader.displayName = 'ModuleLoader';
export default ModuleLoader;

//# sourceMappingURL=ModuleLoader.js.map